import { SwiperOptions } from "swiper/types";

export const heroSwiperConfig: SwiperOptions = {
  slidesPerView: "auto",
  spaceBetween: 8,
  centeredSlides: true,
  loop: true,
  autoplay: { delay: 10000 },
};
